export default "__VITE_ASSET__CBqxdsij__"